import { AdminOrganizationState } from './admin-organization.reducer';
import { createSelector, createFeatureSelector } from '@ngrx/store';
import { AppStore } from '../store.model';
import { AdminOrganization } from 'src/app/admin/models/organization.model';
import { AdminOrganizationApiError } from './admin-organization.errors';

export const getAdminOrganizationState =
  createFeatureSelector<AdminOrganizationState>('adminOrganization');

export const selectAdminAllOrganizations = createSelector<
  AppStore,
  AdminOrganizationState,
  AdminOrganization[]
>(getAdminOrganizationState, (state) => state.organizations);

export const selectAdminIncludeDeletedOrganizations = createSelector(
  getAdminOrganizationState,
  (state) => state.includeDeleted,
);

export const selectAdminOrganizationsPagination = createSelector(
  getAdminOrganizationState,
  ({ total, page, limit }) => ({ total, page, limit }),
);

export const selectAdminOrganizationsSort = createSelector(
  getAdminOrganizationState,
  ({ sortOrder, orderBy }) => ({ sortOrder, orderBy }),
);

export const getAdminOrganizationQuery = createSelector(
  getAdminOrganizationState,
  ({ includeDeleted, page, limit, sortOrder, orderBy, search }) => ({
    includeDeleted,
    page,
    limit,
    sortOrder,
    orderBy,
    search,
  }),
);

export const getAdminActiveOrganizations = createSelector<
  AppStore,
  AdminOrganizationState,
  AdminOrganization[]
>(getAdminOrganizationState, (state) => state.organizations.filter((org) => !org.datetimeDeleted));

export const getAdminCurrentOrganization = createSelector<
  AppStore,
  AdminOrganizationState,
  AdminOrganization
>(getAdminOrganizationState, (state) => state.currentOrganization);

export const getAdminOrganizationError = createSelector<
  AppStore,
  AdminOrganizationState,
  AdminOrganizationApiError
>(getAdminOrganizationState, (state) => state.apiError);
